var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.539,
    height: 21.264,
    viewBox: "0 0 5.539 21.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "About_icon",
    "data-name": "About icon",
    transform: "translate(-15.232 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_chat_icon",
    "data-name": "New chat icon",
    transform: "translate(15.232 14.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M.755-1.28H3.562V11.984H6.294",
    transform: "translate(-0.755 1.28)",
    fill: "none",
    stroke: "#072531",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    transform: "translate(16.001 7)",
    fill: "none",
    stroke: "#072531",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.12fffcae0e1ffdd1e6b8999878141869.svg";
export { ForwardRef as ReactComponent };